<template>
  <div class="etc-page">
    <TextbookPageNav
      v-if="$route.query.barcode"
      :barcode="$route.query.barcode"
      active-tab="contents"
    />

    <APageHead sub="챕터·섹션 구성을 관리합니다.">
      <template #title>
        교재 콘텐츠 편집
        <TextbookHeadTitle v-if="$route.query.barcode" :barcode="$route.query.barcode" />
      </template>
    </APageHead>

    <ACard body-flush>
      <div class="etc-page__steps">
        <button
          v-for="(step, idx) in steps"
          :key="step.id"
          type="button"
          :class="['etc-page__step', { 'is-active': activeStep === idx, 'is-done': activeStep > idx }]"
          @click="activeStep = idx"
        >
          <span class="etc-page__step-num">{{ idx + 1 }}</span>
          <span class="etc-page__step-label">{{ step.label }}</span>
          <i v-if="activeStep > idx" class="material-icons-round etc-page__step-check">check</i>
        </button>
      </div>

      <form class="etc-page__form">
        <chapters-list v-show="activeStep === 0" />
        <sections-list v-show="activeStep === 1" />
      </form>
    </ACard>
  </div>
</template>

<script>
import ChaptersList from "@/components/ChaptersList.vue";
import SectionsList from "@/components/SectionsList.vue";
import eventBus from "@/eventBus";
import TextbookPageNav from "@/components/TextbookPageNav.vue";
import TextbookHeadTitle from "@/components/TextbookHeadTitle.vue";
import APageHead from "@/components/Pineapple/APageHead.vue";
import ACard from "@/components/Pineapple/ACard.vue";

export default {
  name: "EditTextbookContents",
  components: { ChaptersList, SectionsList, TextbookPageNav, TextbookHeadTitle, APageHead, ACard },
  data() {
    return {
      activeStep: 0,
      formSteps: 3,
      steps: [
        { id: "chapters", label: this.$t ? this.$t("label.42") : "챕터 정보" },
        { id: "sections", label: this.$t ? this.$t("label.43") : "섹션 정보" },
      ],
    };
  },
  watch: {
    activeStep(newVal) {
      if (newVal === 1) {
        eventBus.emit("loadStyleFiles");
        eventBus.emit("reloadChapters");
      }
    },
  },
  methods: {
    nextStep() {
      if (this.activeStep < this.formSteps) this.activeStep += 1;
      else this.activeStep -= 1;
    },
    prevStep() {
      if (this.activeStep > 0) this.activeStep -= 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.etc-page {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__steps {
    display: flex;
    gap: 0;
    background: $p-bg;
    padding: 14px 16px;
    border-bottom: 1px solid $p-line;
  }

  &__step {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 12px 16px;
    background: $p-panel;
    border: 1px solid $p-line;
    color: $p-ink-mid;
    font-family: $p-font-body;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: background $p-dur $p-ease, color $p-dur $p-ease, border-color $p-dur $p-ease;

    &:first-child { border-radius: $p-radius 0 0 $p-radius; border-right: 0; }
    &:last-child { border-radius: 0 $p-radius $p-radius 0; }

    &.is-active {
      background: $p-ink;
      color: $p-point;
      border-color: $p-ink;
    }

    &.is-done {
      background: $p-ok-soft;
      color: $p-ok;
      border-color: $p-ok;
    }

    &:hover:not(.is-active):not(.is-done) {
      background: $p-panel-alt;
      color: $p-ink;
    }
  }

  &__step-num {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    display: inline-grid;
    place-items: center;
    font-family: $p-font-mono;
    font-size: 11px;
    font-weight: 800;

    .etc-page__step.is-active & {
      background: $p-point;
      color: $p-ink;
    }

    .etc-page__step.is-done & {
      background: $p-ok;
      color: #fff;
    }
  }

  &__step-check {
    font-size: 14px !important;
  }

  &__form {
    padding: 20px 22px;
  }
}
</style>
